<div class="modal-body p-5 formModal">
    <h1>Request an Introduction to {{memberName}}</h1>

    <!--<p class="submitInstructions">
        
    </p>-->

    <div class="submitFormWrap mt-4">
        <form class="submitForm">
            <div class="row gx-5">
                <div class="col-12">
                    <label for="introReason" class="form-label">50 words or less description of your business to be included in the body of the message.</label>
                    <!--<textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="letterContent" class="form-control" id="introReason" rows="3"></textarea>-->
                    <editor [ngModelOptions]="{standalone: true}" [(ngModel)]="letterContent" licenseKey="gpl" toolbar="false" menubar="false" [init]="{
                        base_url: '/tinymce',
                        suffix: '.min',
                        menubar: false,
                        statusbar: false,
                        plugins: 'wordcount',
                        height: 250,
                      }"></editor>
                </div>
                <div class="col-12 text-center mt-4">
                    <button type="button" (click)="submitLetter()" class="btn btn-secondary m-100 modalSubmitBtn">Submit Request to
                        Chamber</button>
                </div>
                <div class="col-12 text-center mt-3">
                    <a (click)="dismiss()" class="formClose" href="javascript:void(0)">nevermind</a>
                </div>
            </div>
        </form>
    </div>
</div>